/**
 * 連接字串轉換首字大寫的字串
 * Example. get_url -> Get Url , get-url -> Get Url , getUrl -> Get Url
 * @param {*} str
 * @param {*} connectStr
 * @returns
 */
export const toStringCamelCase = (str, connectStr = '_') => {
    if (typeof str !== 'string') return str;

    return (
        str
            // camelCase：在小寫字母/數字與大寫字母之間補上連接字元，全大寫（如 GET_URL）不受影響
            .replace(/([a-z0-9])([A-Z])/g, `$1${connectStr}$2`)
            .toLowerCase()
            .split(connectStr)
            .map(word => {
                // 其他單詞全部轉為大寫
                return word.charAt(0).toUpperCase() + word.slice(1);
            })
            .join(' ')
    );
};

export const setTextVariantStyle = (variant, propertyName) => {
    let fontStyle = `
        font-style: normal;
        font-family: Noto Sans TC, Roboto, Helvetica, Arial, sans-serif;
    `;

    function getPropertyValueFromString(cssString, propertyName) {
        // 誤報：propertyName 全專案僅由本檔以字面值 'line-height' 傳入，非使用者輸入。
        // nosemgrep: eslint.detect-non-literal-regexp
        const pattern = new RegExp(`${propertyName}:\\s*([^;]+);`);
        const match = cssString.match(pattern);

        if (match && match.length === 2) {
            return match[1].trim();
        } else {
            return null;
        }
    }

    switch (variant) {
        case 'h1':
            fontStyle += `
                font-size: 96px;
                font-weight: 500;
                line-height: 1.3;
                letter-spacing: -1px;
            `;
            break;
        case 'h2':
            fontStyle += `
                font-size: 60px
                font-weight: 500;
                line-height: 1.3;
                letter-spacing: -0.5px;
            `;
            break;
        case 'h3':
            fontStyle += `
                font-size: 48px;
                font-weight: 500;
                line-height: 1.3;                
                letter-spacing: -0.5px;
            `;
            break;
        case 'h4':
            fontStyle += `
                font-size: 34px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 0px;
            `;
            break;
        case 'h5':
            fontStyle += `
                font-size: 24px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 0px;
            `;
            break;
        case 'h6':
            fontStyle += `
                font-size: 20px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 0px;
            `;
            break;
        case 'subtitle1':
            fontStyle += `
                font-size: 16px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 0.25px;
            `;
            break;
        case 'subtitle2':
            fontStyle += `
                font-size: 14px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 0.25px;
            `;
            break;
        case 'body1':
            fontStyle += `
                font-size: 16px;
                font-weight: 400;
                line-height: 1.4;
                letter-spacing: 0.25px;
            `;
            break;
        case 'body2':
            fontStyle += `
                font-size: 14px;
                font-weight: 400;
                line-height: 1.4;
                letter-spacing: 0.25px;
            `;
            break;
        case 'button':
            fontStyle += `
                font-size: 14px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 1.25px;
                text-transform: capitalize;
            `;
            break;
        case 'caption':
            fontStyle += `
                font-size: 12px;
                font-weight: 400;
                line-height: 1.5;
                letter-spacing: 0.5px;
            `;
            break;
        case 'overline':
            fontStyle += `
                font-size: 10px;
                font-weight: 500;
                line-height: 1.4;
                letter-spacing: 1.25px;
            `;
            break;
        default:
    }
    if (propertyName) {
        return getPropertyValueFromString(fontStyle, propertyName).replace(/px/, '');
    }
    return fontStyle;
};
